import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
  error: null,
  loading: false,
  email: null,
  emailSent: false,
};

const logInOTPStart = (state) => (
  updateObject(state, {
    error: null,
    loading: true,
    email: null,
    emailSent: false,
  })
);

const logInOTPSuccess = (state, action) => (
  updateObject(state, {
    error: null,
    loading: false,
    email: action.email,
    emailSent: true,
  })
);

const logInOTPFail = (state, action) => (
  updateObject(state, {
    error: action.error,
    loading: false,
  })
);

const reducer = (state = initialState, action = null) => {
  switch (action.type) {
    case actionTypes.LOG_IN_OTP_START:
      return logInOTPStart(state);
    case actionTypes.LOG_IN_OTP_SUCCESS:
      return logInOTPSuccess(state, action);
    case actionTypes.LOG_IN_OTP_FAIL:
      return logInOTPFail(state, action);
    case actionTypes.LOG_IN_OTP_RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
